var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVmware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520.2 79.3",
    style: {
      enableBackground: "new 0 0 520.2 79.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6A6667;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(388.3 250.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-165-177.6l-22.8-63.4c-0.3-0.9-0.7-2-0.7-3.1c0-2.7,2.3-5.4,5.7-5.4c2.9,0,4.8,1.9,5.7,4.6l18.9,54.7 l19-54.8c0.9-2.6,2.6-4.5,5.5-4.5h0.6c3.1,0,4.9,1.9,5.8,4.5l18.9,54.8l19.2-54.9c0.7-2.3,2.3-4.4,5.4-4.4c3.2,0,5.5,2.5,5.5,5.2 c0,1-0.4,2.2-0.7,3.1l-22.9,63.6c-1.2,3.3-3.5,5.1-6.1,5.1h-0.4c-2.9,0-5.1-1.7-6.1-5.1l-18.7-53.9l-18.9,53.9 c-1,3.3-3.2,5.1-6.1,5.1h-0.3C-161.5-172.6-163.9-174.3-165-177.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(436.2 270)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-46.9-263c0-3.1,2.5-5.7,5.5-5.7c3.2,0,5.7,2.5,5.7,5.7v12.9c5.5-12.5,17.8-18.4,25.9-18.4 c3.4,0,5.5,2.5,5.5,5.7c0,3.1-2,5.2-5,5.7c-14.5,1.7-26.5,12.7-26.5,34.3v25.5c0,3.1-2.3,5.7-5.5,5.7c-3.2,0-5.7-2.5-5.7-5.7 L-46.9-263L-46.9-263z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.9 249.2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1-170.1c-20.2,0-36.7-15.7-36.7-38.7v-0.3c0-21.4,15-38.7,35.3-38.7c21.8,0,34.2,18,34.2,37.7 c0,3-2.4,5.2-5.1,5.2h-53.2c1.6,16.1,12.8,25.2,25.9,25.2c9.1,0,15.8-3.6,21.2-8.6c0.9-0.7,1.9-1.3,3.1-1.3c2.7,0,4.8,2.2,4.8,4.8 c0,1.3-0.6,2.6-1.7,3.6C29.9-174.5,21.7-170.1,9.1-170.1 M30.9-213.1c-1.1-13.5-8.8-25.3-23.5-25.3c-12.8,0-22.5,10.8-23.9,25.3 H30.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(413.4 255.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-103.1-200v-0.3c0-15.8,13-24.2,32-24.2c9.6,0,16.4,1.3,23.1,3.2v-2.6c0-13.5-8.3-20.4-22.3-20.4 c-7.5,0-11.9,1-17.4,3.4c-0.7,0.3-1.4,0.4-2,0.4c-2.6,0-4.9-2.2-4.9-4.8c0-2.3,1-3.7,3.1-4.6c7.4-3.2,12.9-4.3,22.5-4.3 c10.6,0,18.7,2.7,24.2,8.3c5.1,5.1,7.7,12.3,7.7,21.9v41.4c0,3.2-2.3,5.5-5.4,5.5c-3.2,0-5.3-2.3-5.3-5.2v-7.1 c-5.2,6.8-13.9,12.9-27.1,12.9C-89-176.6-103.1-184.6-103.1-200 M-47.9-205.8v-7.2c-5.5-1.6-12.9-3.2-22-3.2 c-14,0-21.9,6.1-21.9,15.5v0.3c0,9.4,8.7,14.9,18.8,14.9C-59.2-185.5-47.9-193.9-47.9-205.8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.8 270.2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-309.3-263.9c-2.5-5.4-8.5-7.8-14.2-5.3c-5.7,2.5-7.8,8.8-5.2,14.2l23.8,51.7c3.7,8.1,7.7,12.3,15.1,12.3 c7.9,0,11.4-4.6,15.1-12.3c0,0,20.7-45.2,21-45.7c0.2-0.5,0.9-1.9,3-1.9c1.8,0,3.3,1.4,3.3,3.3v44.2c0,6.8,3.8,12.4,11,12.4 c7.3,0,11.2-5.6,11.2-12.4v-36.2c0-7,5-11.5,11.8-11.5s11.3,4.7,11.3,11.5v36.2c0,6.8,3.8,12.4,11,12.4c7.3,0,11.2-5.6,11.2-12.4 v-36.2c0-7,5-11.5,11.8-11.5c6.8,0,11.3,4.7,11.3,11.5v36.2c0,6.8,3.8,12.4,11,12.4c7.3,0,11.2-5.6,11.2-12.4v-41.2 c0-15.1-12.2-25.7-26.8-25.7c-14.6,0-23.8,10.1-23.8,10.1c-4.9-6.3-11.6-10.1-22.9-10.1c-12,0-22.5,10.1-22.5,10.1 c-4.9-6.3-13.2-10.1-20-10.1c-10.6,0-19,4.7-24.2,16.4l-15.2,35.8L-309.3-263.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(468.6 268.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.1-258L33.1-258c0-5.1,4.1-9.4,9.3-9.4c5.2,0,9.3,4.2,9.3,9.3v0c0,5.1-4.1,9.3-9.3,9.3 C37.1-248.8,33.1-253,33.1-258 M49.8-258.1L49.8-258.1c0-4.2-3.2-7.6-7.5-7.6c-4.2,0-7.5,3.5-7.5,7.6v0c0,4.1,3.2,7.6,7.5,7.6 C46.6-250.5,49.8-254,49.8-258.1"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(470.3 270)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.2-263c0-0.6,0.4-1,1-1h3.1c1.2,0,2.1,0.3,2.6,0.9c0.5,0.5,0.8,1.2,0.8,2v0c0,1.4-0.7,2.3-1.8,2.7l1.4,1.7 c0.2,0.2,0.3,0.5,0.3,0.8c0,0.5-0.5,0.9-0.9,0.9c-0.4,0-0.7-0.2-1-0.5l-1.9-2.4h-1.6v2c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1L37.2-263 L37.2-263z M41.2-259.6c1,0,1.5-0.5,1.5-1.3v0c0-0.8-0.6-1.3-1.5-1.3h-2v2.6L41.2-259.6L41.2-259.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVmware);
export default __webpack_public_path__ + "static/media/Vmware.1b172132b2383c938c80c767cf38d9aa.svg";
export { ForwardRef as ReactComponent };